import PropTypes from "prop-types"

const DrilldownObjectShape = {
  name: PropTypes.string,
  y: PropTypes.number,
  drilldown: PropTypes.string,
  count: PropTypes.number,
}
export default DrilldownObjectShape



// WEBPACK FOOTER //
// ./src/state/shapes/DrilldownShapes/DrilldownObjectShape.js